// extracted by mini-css-extract-plugin
export default {"root":"Chat_root__dCX2j","messages":"Chat_messages__bF68V","messages__items":"Chat_messages__items__8MO2i"};